<template>
  <div>
    <template v-if="this.data != null">
      <keep-alive>
        <!--         <v-tabs show-arrows="always" v-model="tabs2" background-color="transparent">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab>Vyhledávání a filtrace</v-tab>
          <v-tab-item class="ma-2"> AAA </v-tab-item>
        </v-tabs>

        <br /> -->

        <v-tabs show-arrows="always" v-model="tabs" background-color="transparent">
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab>Vyhledávání a filtrace</v-tab>

          <v-tab v-for="(item, index) in category" :key="index" @click="getData()">
            {{ $t("parameters.category." + item) }}
          </v-tab>

          <v-tab>{{ $t("parameters.headers.save") }}</v-tab>

          <v-tab-item class="ma-2">
            <v-row>
              <v-col cols="12">
                <h3>Filtrace dle jednotky:</h3>
              </v-col>

              <v-col cols="auto" v-for="(item, index) in data.units" :key="index">
                <v-checkbox dense v-model="searchCheckboxes" :label="item.name" color="primary" :value="item.address" hide-details> </v-checkbox>
              </v-col>

              <v-col cols="12" align="end">
                <v-hover v-slot="{ hover }">
                  <v-btn :small="true" :plain="true" @click="saveFilter()">
                    <v-row justify="center">
                      <v-col cols="auto" class="d-flex justify-center" align="center">
                        <v-icon :elevation="hover ? 12 : 0" :color="hover ? 'primary' : 'secondary'"> mdi-floppy </v-icon>
                      </v-col>
                      <v-col cols="auto" class="d-flex mt-1 justify-center" align="center">
                        <span> Uložit </span>
                      </v-col>
                    </v-row>
                  </v-btn>
                </v-hover>
              </v-col>

              <!--               
              <v-col cols="12">
                <h3>Filtrace dle názvu parametru:</h3>
              </v-col>

              <v-col cols="12">
                <v-text-field dense>AA </v-text-field>
              </v-col> 
              -->

              <!--               
              <v-col cols="12">
                {{ searchCheckboxes }}
              </v-col> -->

              <!--            dataStructCat: {{ dataStructCat }} <br />
              <br />

              category: {{ category }} <br />
              <br />

              subcategoryUniqueNames: {{ subcategoryUniqueNames }} <br />

              <br /> -->

              <!-- 
              <v-col cols="12">
                <h3>Filtrace parametrů dle jména parametru:</h3>
              </v-col> 
              -->
            </v-row>
          </v-tab-item>

          <v-tab-item v-for="(item, index) in category" :key="index" class="ma-2">
            <ParametersCoreCategory :data="dataStructCatFiltered" :subcategory="subcategoryUniqueNames" :category="item" :locale="locale" :distributor="distributor" />
          </v-tab-item>

          <v-tab-item class="ma-4">
            <v-row>
              <v-col cols="auto" v-for="(item, index) in data.units" :key="index">
                <v-checkbox v-model="checkboxes" :label="item.name" color="primary" :value="item.address" hide-details> </v-checkbox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <CommandDialog
                  :command="'setdefault' + this.commandParameters"
                  type="parameters"
                  buttonColor="red"
                  :cardTitle="$t('calibration.setdefaultconfiguration')"
                  :cardText="$t('calibration.defaultconfigurationareyousure')"
                  :actionYes="$t('calibration.yes')"
                  :actionNo="$t('calibration.no')"
                />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <CommandDialog :command="'save' + this.commandParameters" type="parameters" buttonColor="primary" :cardTitle="$t('calibration.saveconfiguration')" :cardText="$t('calibration.saveconfigurationareyousure')" :actionYes="$t('calibration.yes')" :actionNo="$t('calibration.no')" />
              </v-col>
            </v-row>

            <br />
            <br />

            <v-row>
              <v-col cols="auto">
                <ButtonHover :disabled="user.roles[0] != 'EC_USER' ? false : true" class="ma-2" :command="'setlocale'" :icons="['mdi-translate']" :plain="true" :small="false" span="Nastavit zvolenou zemi instalace"></ButtonHover>
              </v-col>

              <v-col cols="auto">
                <ButtonHover :disabled="user.roles[0] != 'EC_USER' ? false : true" class="ma-2" :command="'setdistributor'" :icons="['mdi-transmission-tower']" :plain="true" :small="false" span="Nastavit zvoleného distributora"></ButtonHover>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="auto">
                <i class="ma-2">Nastavení distributora a země od <b>44.13+ CCU</b> a <b>44.16+ INV</b> </i>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </keep-alive>
    </template>
    <template v-else>
      <LoadingData />
    </template>
    <UpgradeCore />
  </div>
</template>

<script>
import ButtonHover from "../../components/button/ButtonHover.vue";
import CommandDialog from "../../components/dialog/CommandDialog.vue";

import ParametersCoreCategory from "../../components/ParametersCoreCategory.vue";

import UpgradeCore from "../../components/upgrade/UpgradeCore.vue";
import LoadingData from "../../components/LoadingData.vue";

import { ServiceClient } from "../../service_client/index.js";
import { mapState } from "vuex";

export default {
  name: "Parameters",
  components: {
    ButtonHover,
    CommandDialog,
    LoadingData,
    ParametersCoreCategory,
    UpgradeCore,
  },
  data() {
    return {
      user: JSON.parse(sessionStorage.getItem("user")),

      category: ["battery", "nominal", "limit", "calibration", "ppds", "others", "fan", "bit", "mppt"],

      mobile: false,

      // Inverter, DAB1, MPPT1, MPPT2
      searchCheckboxes: ["EE10", "EE61", "EE30", "EE31"],

      checkboxes: [],
      commandParameters: "",

      tabs: 0,

      view: "units",

      locale: [],
      distributor: [],

      data: null,
      dataStructCat: null,
      dataStructCatFiltered: null,
      subcategoryUniqueNames: null,

      timeoutDataTimer: null,

      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  created() {
    this.getBreakpoints();
    this.getData();

    this.loadFilter();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  methods: {
    loadFilter() {
      if (localStorage.getItem("paramFilters") !== null) {
        this.searchCheckboxes = JSON.parse(localStorage.getItem("paramFilters"));
      }
    },
    saveFilter() {
      localStorage.setItem("paramFilters", JSON.stringify(this.searchCheckboxes));
    },
    updateFilters(data) {
      const filteredArray = this.searchCheckboxes.length > 0 ? data.filter((item) => this.searchCheckboxes.includes(item.unitAddress)) : data;

      return filteredArray;
    },
    getParameterValueForGivenName(searchArray, name) {
      for (let index = 0; index < searchArray.length; index++) {
        if (searchArray[index].name == name) {
          return searchArray[index].value;
        }
      }
    },
    sortIntoStructCat(data) {
      let newFuckingArray = [];

      let newFuckingObject;

      for (let i = 0; i < data.units.length; i++) {
        for (let j = 0; j < data.units[i].parameters.length; j++) {
          newFuckingObject = data.units[i].parameters[j];

          newFuckingObject = {
            ...newFuckingObject,
            ...{
              unitName: data.units[i].name,
              unitType: data.units[i].type,
              unitAddress: data.units[i].address,
            },
          };

          newFuckingArray.push(newFuckingObject);
        }
      }

      return newFuckingArray;
    },
    getUniqueCategoryNames(data) {
      let newArray = [];

      for (let i = 0; i < data.length; i++) {
        if ("cat" in data[i]) {
          if (!newArray.includes(data[i].cat)) {
            if (data[i].cat != "") {
              newArray.push(data[i].cat);
            }
          }
        }
      }

      return newArray;
    },
    getUniqueSubCategoryNames(data) {
      let newArray = [];

      for (let i = 0; i < data.length; i++) {
        if ("subcat" in data[i]) {
          if (!newArray.includes(data[i].subcat)) {
            if (data[i].subcat != "") {
              newArray.push(data[i].subcat);
            }
          }
        }
      }

      return newArray;
    },
    changeView(String) {
      this.tabs = 0;
      this.view = String;
    },
    onResize() {
      this.getBreakpoints();
    },
    getBreakpoints() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;

      if (this.windowWidth < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, null, "GET")
        .then((data) => {
          clearInterval(this.timeoutDataTimer);

          this.processData(data);
        })
        .catch((error) => {
          if (this.timeoutDataTimer == null) {
            this.timeoutDataTimer = setInterval(() => {
              this.getData();
            }, 3000);
          }

          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    processData(data) {
      this.data = data;

      this.dataStructCat = this.sortIntoStructCat(data);

      this.dataStructCatFiltered = this.updateFilters(this.dataStructCat);

      this.subcategoryUniqueNames = this.getUniqueSubCategoryNames(this.dataStructCatFiltered);

      this.category = [];

      this.category = this.getUniqueCategoryNames(this.dataStructCatFiltered);

      let localeValue = this.getParameterValueForGivenName(this.dataStructCatFiltered, "Locale");
      let distributorValue = this.getParameterValueForGivenName(this.dataStructCatFiltered, "Distributor");

      this.locale = "+" + localeValue + " " + this.$t("settings.localeCode." + localeValue);
      this.distributor = distributorValue + ")" + " " + this.$t("settings.distributorCode." + distributorValue);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    checkboxes: function () {
      this.commandParameters = "&units=" + this.checkboxes.join(",");
    },
    searchCheckboxes: function () {
      if (this.dataStructCat != null && this.data != null) {
        this.updateFilters(this.dataStructCat);

        this.processData(this.data);
      }
    },
  },
};
</script>

<style scoped></style>
